var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import { Tab } from './Tab';
export var Tabs = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, defaultActiveId = _a.defaultActiveId, activeIdProp = _a.activeId, onChange = _a.onChange, props = __rest(_a, ["className", "children", "defaultActiveId", "activeId", "onChange"]);
    var _c = React.useState(defaultActiveId !== (null || undefined) ? defaultActiveId : activeIdProp), localActiveId = _c[0], setLocalActiveId = _c[1];
    var activeId = activeIdProp || localActiveId;
    var activeContent = React.Children.toArray(children).filter(function (el) { return el.props.id === activeId; })[0];
    function onChangeId(id) {
        setLocalActiveId(id);
        typeof onChange === 'function' && onChange(id);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", __assign({ className: clsx('', className) }, props), React.Children.toArray(children).map(function (tab) {
            return React.cloneElement(tab, {
                onClick: function () { return onChangeId(tab.props.id); },
                active: activeId === tab.props.id,
            });
        })), (_b = activeContent === null || activeContent === void 0 ? void 0 : activeContent.props) === null || _b === void 0 ? void 0 :
        _b.children));
};
Tabs.Tab = Tab;
